import { PropsWithChildren } from 'react';

import config from '@config';
import {
  NotificationsSignalRProvider,
  SignalRAuthAdapter,
  useNotificationsSignalRContext,
} from '@gasbi/shared';

import http from '@/utils/http';

const useAuthAdapter = (): SignalRAuthAdapter => ({
  signinSilent: async () => {
    const response = await http.get('/user', { validateStatus: () => true });
    if (response.status === 401) {
      throw { error: 'login_required' };
    }
  },
  signoutRedirect: async () => {
    const returnUrl = window.location.pathname + window.location.search;
    window.location.assign(`/api/login?returnUrl=${encodeURIComponent(returnUrl)}`);
  },
});

export const SignalRProvider = ({ children }: PropsWithChildren) => (
  <NotificationsSignalRProvider
    hubUrl={config.VITE_WS_API_URL}
    useAuthAdapter={useAuthAdapter}
  >
    {children}
  </NotificationsSignalRProvider>
);

export const useSignalRContext = useNotificationsSignalRContext;
